import { parallaxImages } from "../common/animations/parrallaxImages.js";

// gsap animations for wysiwyg block
const gsapWysiwygAnimations = () => {
	const wrapper = document.querySelectorAll(".wp-block-create-block-wysiwyg");

	if (!wrapper.length) return;

	// Animate wysiwyg block elements
	const animateElements = () => {
		wrapper.forEach((wrapper) => {
			const elements = wrapper.querySelectorAll(
				".wp-block-create-block-wysiwyg > *",
			);

			if (elements.length > 0) {
				gsap.set(elements, {
					opacity: 0,
					y: 30,
				});

				ScrollTrigger.batch(elements, {
					start: "top 95%",
					end: "bottom 20%",
					onEnter: (elements) => {
						gsap.to(elements, {
							opacity: 1,
							y: 0,
							duration: 1,
							stagger: 0.3,
							ease: "power2.out",
						});
					},
				});
			}
		});
	};

	animateElements();
	parallaxImages(wrapper);
};

// Initialize everything when DOM is ready
if (document.readyState !== "loading") {
	gsapWysiwygAnimations();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		gsapWysiwygAnimations();
	});
}
